const REDIRECT_STATUS_CODE = 302

export const redirectToHomePage = (res, customCode) => {
  if (res?.writeHead) {
    res.writeHead(customCode || REDIRECT_STATUS_CODE, { Location: '/' })
  }
}

export const isAuthCookiesAvailable = (auth) => auth && auth.user

export const getProductIDs = (products = []) =>
  products.map((product) => product.id_product || product.id_product_2)
